export default __webpack_public_path__ + "static/media/me.bbec287e.png";